/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { string } from 'prop-types';

import Button from 'components/Button/Button';

import styles from './double-cta-block.scss';

/**
 * This is the DoubleCtaBlock component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class DoubleCtaBlock extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    title: string.isRequired,
    content_left: string.isRequired,
    content_right: string.isRequired,
    button_text_left: string,
    button_text_right: string,
    url_left: string,
    url_right: string,
  };

  static defaultProps = {
    button_text_left: null,
    button_text_right: null,
    url_left: null,
    url_right: null,
  };

  /**
   * Render CtaBlock.
   *
   * @return {Object}
   */
  render() {
    const {
      title,
      content_left,
      content_right,
      button_text_left,
      button_text_right,
      url_left,
      url_right,
    } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <h2>{title}</h2>
        </div>
        <div className={styles.blocks}>
          <div className={styles.text}>
            {button_text_left && (
              <div className={styles.button}>
                <Button path={url_left}>{button_text_left}</Button>
              </div>
            )}
            <p dangerouslySetInnerHTML={{ __html: content_left }} />
          </div>
          <div className={styles.text}>
            {button_text_right && (
              <div className={styles.button}>
                <Button path={url_right}>{button_text_right}</Button>
              </div>
            )}
            <p dangerouslySetInnerHTML={{ __html: content_right }} />
          </div>
        </div>
      </div>
    );
  }
}
